import { useCallback, useState } from "react";
import type { SortSelection } from "@src/features/clips/types/camera";

interface UseCameraSearchSortOptions {
  initialSearchQuery?: string;
  initialSortBy?: SortSelection;
}

export function useCameraSearchSort({ initialSearchQuery = "", initialSortBy = [] }: UseCameraSearchSortOptions = {}) {
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery);
  const [sortBy, setSortBy] = useState<SortSelection>(initialSortBy);

  const reset = useCallback(() => {
    setSearchQuery(initialSearchQuery);
    setSortBy(initialSortBy);
  }, [initialSearchQuery, initialSortBy]);

  return {
    searchQuery,
    setSearchQuery,
    sortBy,
    setSortBy,
    reset,
  };
}
